var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 16C3.25 8.9703 8.9703 3.25 16 3.25C23.0297 3.25 28.75 8.9703 28.75 16C28.75 23.0297 23.0297 28.75 16 28.75C8.9703 28.75 3.25 23.0297 3.25 16Z",
    stroke: "black",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1328 19.8732V12.122L16.859 13.9285L19.9816 15.9976L14.1328 19.8732Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleSolid);
export default __webpack_public_path__ + "static/media/play-circle-solid.c6f5c030dd138096796ced96fca7f9ee.svg";
export { ForwardRef as ReactComponent };